import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { faMoneyCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { chequeStatuses, getRemainedAccount,  keyIsLetterOrNumber, useIsMobileApp } from "../../store/api/CommonFunctions";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { Fragment, useEffect, useRef, useState } from "react";
import { Book, CheckLg, DashCircle, ExclamationTriangle, List, Pencil, PlusSquare, PlusSquareFill, Printer, Trash } from "react-bootstrap-icons";
import Loader from "react-loader-spinner";
import BihamtaTable from "../../Components/BihamtaTable";
import { useForm } from "react-hook-form";
import NewNumberInput from "../../Components/NewNumberInput";
import { addEditChequeFunction, getAllBankAccount, getChequeFunction, getChequeFunctionByChequeID, deleteChequeFunction, searchForCheque } from "../store/api/DocumentsAPI";
import ModalSelectCheque from "./ModalSelectCheque";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";

const ModalAddEditChequeFunctions = (props) => {
    const { popData, setPopData } = props;
    const { ChequeStatus, ChequeID, Mixed, FunctionID, InvoiceID, InvoiceDocumentID, InvoiceType, Show, AccountID, AccountCat, AccountName, AccountCode, onInvoicePay, onDeleteInvoiceCheque } = popData;

    const filterData = useSelector(state => state.DocumentReducer?.cheqSearchFilters ?? { Take: 10, Skip: 0 });

    const frmRow = useRef();
    const inputDate = useRef();
    const inputChqNum = useRef();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [pending, setPending] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const { errors, register, handleSubmit } = useForm();
    const [bankList, setBankList] = useState({ Data: [] });
    const [currentRow, setCurrentRow] = useState(null);
    const [remainedAcc, setRemainedAcc] = useState('');
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [modalSelectCheq, setModalSelectCheq] = useState({ Show: false });
    const [chequefunction, setChequeFunction] = useState({
        DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD"),
        ChequeFunctionRows: []
    });
    const showPay = Mixed || (Number(chequefunction.CashTargetAccountID ?? 0) > 0);
    const [popCustomer, setPopCustomer] = useState({ show: false });
    let title = "";
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "شماره چک", colName: "ChequeNumber", showInMobile: true },
        { colTitle: "تاریخ سررسید", colName: "PDueDate", showInMobile: true },
        { colTitle: "نام بانک و شعبه", colName: "BankName" },
        { colTitle: "شماره حساب جاری", colName: "BankAccountNo" },
        { colTitle: "مبلغ چک", colName: "ChequeAmount", colType: "currency" },
        { colTitle: "پشت نمره", colName: "ChequeBackNo" }
    ]
    const tableRows = [
        { type: "delete", title: "حذف ردیف", onclick: deleteRow }
    ]
    switch (ChequeStatus) {
        case chequeStatuses.in_1_RecieveCheque:
            title = "دریافت چک";
            if (showPay) {
                title = "دریافت مرکب"
            }
            break;
        case chequeStatuses.in_2_PutInAccount:
            title = "به حساب گذاشتن چک";
            break;
        case chequeStatuses.in_3_GiveToCustomer:
            title = "واگذاری چک";
            break;
        case chequeStatuses.in_4_Cash:
            title = "وصول چک";
            break;
        case chequeStatuses.in_5_NotCash:
            title = "عدم وصول چک";
            break;
        case chequeStatuses.in_6_ReturnAndCustomerPay:
        case chequeStatuses.in_7_ReturnAndCustomerNotPay:
            title = "عودت چک";
            break;
        case chequeStatuses.in_8_CustomerReturns:
            title = "دریافت چک برگشتی";
            break;
        case chequeStatuses.out_1_PayCheque:
            title = "پرداخت چک";
            if (showPay) {
                title = "پرداخت مرکب";
            }
            break;
        case chequeStatuses.out_2_PassCheque:
            title = "پاس شدن چکهای پرداختی";
            break;
        case chequeStatuses.out_3_CustomerReturns:
            title = "برگشت چکهای پرداختی";
            break;
        case chequeStatuses.out_4_PaidChequeReversal:
            title = "عودت چکهای پرداختی";
            break;            
        default:
            break;
    }
    function close() {
        setPopData({
            Show: false
        })
        setChequeFunction({
            DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD"),
            ChequeFunctionRows: []
        })
        setCurrentRow(null);
        setRemainedAcc('');
        setSubmitError(null);

    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            if (data) {
                setChequeFunction({ ...chequefunction, AccountCat: data.Cat, AccountID: data.ID, AccountName: data.Name, AccountCode: data.Code });

                getRemainedAccount(data.ID, data.Cat, setRemainedAcc);
            }
        }
        setPopCustomer({
            show: true, value: e.key, invoiceCustomers: true,
            setCustomerData: onSelectCustomer
        });
    }
    function prepareForAdd() {
        if (/*ChequeStatus === chequeStatuses.out_1_PayCheque ||*/ ChequeStatus === chequeStatuses.in_1_RecieveCheque) {
            setCurrentRow({
                RowIndex: 0,
                ShowIndex: chequefunction.ChequeFunctionRows.length + 1,
                IsNew: true
            })
        }
        else {
            showModalSelectCheq();
        }
    }
    function addEditRow(data) {
        const pDueDate = inputDate.current.input.value;
        if (pDueDate === "" || Number(data.ChequeAmount) === 0) {
            return;
        }
        data.ChequeAmount = Number(data.ChequeAmount);
        if (!chequefunction.ChequeFunctionRows) {
            chequefunction.ChequeFunctionRows = [];
        }
        if (currentRow.IsNew) {
            chequefunction.ChequeFunctionRows.push({
                ...data,
                DueDate: currentRow.DueDate,
                PDueDate: pDueDate
            })
            setCurrentRow(null);
            setTimeout(() => {
                setCurrentRow({ RowIndex: 0, IsNew: true, ShowIndex: chequefunction.ChequeFunctionRows.length + 1 });
                inputChqNum.current?.focus();
            }, 5);

        }
        else if (!currentRow.IsNew) {
            if (Number(data.RowIndex) > 0) {
                const oldRow = chequefunction.ChequeFunctionRows.find(r => Number(r.ShowIndex) === Number(data.ShowIndex));
                oldRow.SignedForDelete = true;
                data.RowIndex = 0;
                chequefunction.ChequeFunctionRows.push({
                    ...data,
                    DueDate: currentRow.DueDate,
                    PDueDate: pDueDate
                })
            }
            else {
                const editingRow = chequefunction.ChequeFunctionRows.find(r => Number(r.ShowIndex) === Number(data.ShowIndex));
                Object.assign(editingRow, data);
                setCurrentRow(null);
            }
        }
        chequefunction.ChequeTotalAmount = chequefunction.ChequeFunctionRows.filter(c => !c.SignedForDelete).map(d => d.ChequeAmount).reduce((a, b) => a + b, 0);
        setChequeFunction({ ...chequefunction });

    }
    function cancelRow() {
        setCurrentRow(null);
    }
    // function prepareForEdit(row) {
    //     if (row.e) {
    //         delete row.e;
    //     }
    //     setCurrentRow({ ...row });
    // }
    function submitChequeFunction() {
        if (pending) {
            return;
        }
        setSubmitError(null);
        if (!chequefunction.ChequeFunctionRows || !chequefunction.ChequeFunctionRows.some(c => !c.SignedForDelete)) {
            setSubmitError({ Variant: "danger", Message: "ردیفی ثبت نشده است" });
            return;
        }
        if ((chequefunction.AccountID ?? "") === "" || (chequefunction.AccountCat ?? "") === "") {
            setSubmitError({ Variant: "danger", Message: "طرف حساب انتخاب نشده است" });
            return;
        }
        if (showPay && Number(chequefunction.CashToPay) > 0) {
            if (!chequefunction.CashTargetAccountID) {
                setSubmitError({ Variant: "danger", Message: "حساب مقصد وجه نقد انتخاب نشده است" });
                return;
            }

        }
        setCurrentRow(null);
        setPending(true);
        const onSuccess = (res) => {
            if (res.Error) {
                setSubmitError({ Variant: "danger", Message: res.Error });
                setPending(false);
            }
            else if (res.Data) {
                setPending(false);
                if (onInvoicePay) {
                    onInvoicePay(res.Data);
                    close();
                    return;
                }
                const onGet = (getResult) => {
                    if (getResult === "PENDING") {
                        setChequeFunction("PENDING");
                    }
                    else if (getResult.Data) {
                        setSubmitError({ Variant: "success", Message: "ثبت با موفقیت انجام شد" });
                        setChequeFunction(getResult.Data);
                    }
                }
                if (Number(chequefunction.FunctionID ?? 0) === 0) {
                    // setSubmitError({ Variant: "success", Message: "ثبت با موفقیت انجام شد" });
                    // setChequeFunction({
                    //     ...chequefunction,
                    //     DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD"),
                    //     ChequeFunctionRows: [],
                    //     ChequeTotalAmount: 0
                    // })
                    // setRemainedAcc('');
                    chequefunction.FunctionID = res.Data;
                }
                //else if (Number(chequefunction.FunctionID) > 0) {

                getChequeFunction(chequefunction.FunctionID, onGet);
                //}
            }
        }
        chequefunction.ChequeStatus = ChequeStatus;
        if (showPay) {
            chequefunction.PayInvoiceID = InvoiceID;
            chequefunction.PayInvoiceType = InvoiceType;
            chequefunction.PayDocumentID = InvoiceDocumentID;
        }
        addEditChequeFunction(chequefunction, onSuccess);
    }
    function showModalSelectCheq(e) {

        if (ChequeStatus === chequeStatuses.out_1_PayCheque) {
            if (e?.key) {
                if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                    return;
                }
                e.preventDefault();
            }
        }
        if (ChequeStatus === chequeStatuses.in_4_Cash ||
            ChequeStatus === chequeStatuses.in_5_NotCash ||
            ChequeStatus === chequeStatuses.in_6_ReturnAndCustomerPay ||
            ChequeStatus === chequeStatuses.out_3_CustomerReturns ||
            ChequeStatus === chequeStatuses.out_4_PaidChequeReversal ||
            ChequeStatus === chequeStatuses.in_8_CustomerReturns) {
            if (!(Number(chequefunction.AccountID) > 0)) {
                setSubmitError({ Variant: "danger", Message: "حسابی انتخاب نشده است" });
                return;
            }
            else {
                setSubmitError(null);
            }

        }
        if (ChequeStatus === chequeStatuses.out_1_PayCheque) {
            const onSelect = (row) => {
                setCurrentRow({
                    BankID: row.BankID,
                    ChequeNumber: row.ChequeNumber,
                    BankName: row.BankName,
                    BankAccountNo: row.BankAccountNo,
                    ChequeID: row.ChequeID,
                    RowIndex: 0,
                    IsNew: true,
                    ShowIndex: chequefunction.ChequeFunctionRows.length + 1
                })
            }
            setModalSelectCheq({
                Show: true,
                Value: e?.key ?? "",
                ChequeStatus: ChequeStatus,
                onSelect: onSelect
            })
        }
        else if (ChequeStatus !== chequeStatuses.in_1_RecieveCheque) {
            const onSelect = (rows) => {
                for (let i = 0; rows?.length > 0 && i < chequefunction.ChequeFunctionRows.length; i++) {
                    const row = chequefunction.ChequeFunctionRows[i];
                    const foundIndex = rows.findIndex(r => Number(r.ChequeID) === Number(row.ChequeID));
                    if (foundIndex > -1) {
                        rows.splice(foundIndex, 1);
                    }
                }
                if (rows?.length > 0) {
                    for (let i = 0; i < rows.length; i++) {
                        rows[i].ShowIndex = chequefunction.ChequeFunctionRows.length + i + 1;
                    }
                    chequefunction.ChequeFunctionRows.push(...rows);
                    chequefunction.ChequeTotalAmount = chequefunction.ChequeFunctionRows.filter(c => !c.SignedForDelete).map(d => d.ChequeAmount).reduce((a, b) => a + b, 0);
                    setChequeFunction({ ...chequefunction });
                }
            }
            setModalSelectCheq({
                Show: true,
                Value: "",
                ChequeStatus: ChequeStatus,
                onSelect: onSelect,
                selectMany: true,
                AccountID: chequefunction.AccountID,
                AccountCat: chequefunction.AccountCat
            })
        }
    }
    // function onChangeCheqInfo(e) {
    //     currentRow[e.target.name] = e.target.value;
    //     setCurrentRow({ ...currentRow });
    // }
    function deleteRow(row) {
        if (Number(row.RowIndex ?? 0) === 0) {
            chequefunction.ChequeFunctionRows = chequefunction.ChequeFunctionRows.filter(r => r.ShowIndex !== row.ShowIndex);
        }
        else if (Number(row.RowIndex) > 0) {
            const deletedRow = chequefunction.ChequeFunctionRows.find(c => Number(c.RowIndex) === Number(row.RowIndex));
            deletedRow.SignedForDelete = true;
        }
        chequefunction.ChequeTotalAmount = chequefunction.ChequeFunctionRows.filter(c => !c.SignedForDelete).map(d => d.ChequeAmount).reduce((a, b) => a + b, 0);
        setChequeFunction({ ...chequefunction });
    }
    function gotoDocument() {
        window.open(`/Accounting/AddEditDocument/${chequefunction.DocumentID}`);
    }
    function setBank(e) {
        chequefunction.AccountID = e.target.value;
        chequefunction.AccountCat = 2;
    }
    function showModalAccLevel3(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (data) {
                chequefunction.CashTargetAccountName = data.AccountName;
                chequefunction.CashTargetAccountID = data.AccountID;
                chequefunction.CashTargetAccountCat = data.AccountCat;
                setChequeFunction({ ...chequefunction });
            }
        }
        setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
        const inputDesc = document.getElementsByName("RowDescription")[0];
        if (inputDesc)
            inputDesc.focus();
    }
    function deleteF() {
        const onDelete = (res) => {
            if (res === "Success") {
                close();
                if (!(Number(InvoiceID) > 0)) {
                    dispatch(searchForCheque(filterData));
                }
                else if (onDeleteInvoiceCheque) {
                    onDeleteInvoiceCheque();
                }
            }
            else if (res.Error) {
                setSubmitError({ Variant: "danger", Message: res.Error });
            }
        }
        deleteChequeFunction(chequefunction.FunctionID, onDelete);
    }
    const printData = {
        method: "get",
        dataUrl: Number(FunctionID) > 0 ? `api/DocumentsAPI/GetChequeFunction?functionID=${FunctionID}` :
            `api/DocumentsAPI/GetChequeFunctionByChequeID?cheqStatus=${ChequeStatus}&cheqID=${ChequeID}`

    }
    function printCheque(e) {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "Cheque" });
    }
    function newCheue() {
        setCurrentRow(null);
        setRemainedAcc('');
        setChequeFunction("PENDING");
        setTimeout(() => {
            setChequeFunction({
                DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD"),
                ChequeFunctionRows: []
            });
        }, 10);

    }
    function onDateChange(value) {
        if (value.local("en").format("YYYY-MM-DD") !== momentJalaali(chequefunction?.DocumentDate).local("en").format("YYYY-MM-DD"))
            setChequeFunction({ ...chequefunction, DocumentDate: value.local("en").format("YYYY-MM-DD") });
    }
    useEffect(() => {
        if (!Show) {
            return;
        }
        const onGet = (res) => {
            if (res === "PENDING") {
                setChequeFunction("PENDING");
            }
            else if (res.Data) {
                setChequeFunction(res.Data);
            }
        }
        if (Number(FunctionID) > 0) {

            getChequeFunction(FunctionID, onGet);
        }
        else if ((ChequeStatus ?? "") !== "" && Number(ChequeID) > 0) {
            getChequeFunctionByChequeID(ChequeStatus, ChequeID, onGet);
        }
        else if (Number(FunctionID) === 0 && Number(AccountID) > 0) {
            setChequeFunction({
                ...chequefunction,
                AccountID: AccountID,
                AccountCat: AccountCat,
                AccountName: AccountName,
                AccountCode: AccountCode ?? ""
            })
        }
        if (ChequeStatus === chequeStatuses.in_2_PutInAccount || ChequeStatus === chequeStatuses.in_4_Cash || ChequeStatus === chequeStatuses.in_5_NotCash || ChequeStatus === chequeStatuses.out_2_PassCheque) {
            getAllBankAccount("", setBankList);
        }
    }, [Show])

    return (
        <>
            <ModalPrintViewer /*{...printData}*/ modalData={modalPrintData} setModalData={setModalPrintData} jsonObject={chequefunction}/>
            <Modal size="lg" show={Show} onHide={() => { }}>
                <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                <ModalSelectCheque popData={modalSelectCheq} setPopData={setModalSelectCheq} />
                {showPay && <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />}
                <Modal.Header className="headerStyle">
                    <span>
                        <FontAwesomeIcon icon={faMoneyCheck} size="lg" />&nbsp;{title}
                    </span>
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
                </Modal.Header>
                <Modal.Body className="bodyStyle" style={{ paddingTop: "0px" }}>
                    {
                        chequefunction === "PENDING" &&
                        <div className="mt-2" style={{ width: "100%", textAlign: "center" }}>
                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                        </div>
                    }
                    {
                        chequefunction?.DocumentDate &&
                        <Fragment>
                            <Row style={{ justifyContent: "space-between" }}>
                                <Col md={ChequeStatus === chequeStatuses.in_2_PutInAccount || ChequeStatus === chequeStatuses.in_4_Cash || ChequeStatus === chequeStatuses.in_5_NotCash ? 4 : 8} className="form-group">
                                    {
                                        ChequeStatus !== chequeStatuses.in_2_PutInAccount && ChequeStatus !== chequeStatuses.in_4_Cash && ChequeStatus !== chequeStatuses.in_5_NotCash && ChequeStatus !== chequeStatuses.out_2_PassCheque &&
                                        <Row>
                                            <label>طرف حساب: </label>
                                            <Col md={7} style={{ maxHeight: "max-content" }} >
                                                <Form.Control onKeyDown={e => showModalCustomer(e)} readOnly value={[chequefunction.AccountCode, chequefunction.AccountName].filter(c => c?.length > 0).join("-")} />
                                                <Button className="btn-input-tiny" style={{ top: "8px", left: "6px" }} onClick={showModalCustomer}><List size={21} /></Button>
                                            </Col>
                                            <Col md={4} className="mt-1" style={{ display: "flex", paddingRight: isMobile ? "12px" : "0px" }}>
                                                {!isNaN(remainedAcc.RemainedAccount) && Number(remainedAcc.RemainedAccount) !== 0 && <span style={{ color: remainedAcc.Color, marginTop: "auto", marginBottom: "auto", border: "2px solid #3b629b", borderRadius: "3px", padding: "4px" }}>{Math.abs(Number(remainedAcc.RemainedAccount)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) + remainedAcc.Type}</span>}
                                                {remainedAcc === "PENDING" && <span style={{ position: "absolute", top: "35px", left: "-120px" }}><Loader type="BallTriangle" width={15} height={15} color="#bb1370" /></span>}
                                            </Col>
                                        </Row>
                                    }
                                    {
                                        (ChequeStatus === chequeStatuses.in_2_PutInAccount || ChequeStatus === chequeStatuses.in_4_Cash || ChequeStatus === chequeStatuses.in_5_NotCash || ChequeStatus === chequeStatuses.out_2_PassCheque) &&
                                        <Fragment>
                                            <label>انتخاب حساب: </label><span style={{ color: "red" }}>*</span>
                                            {
                                                bankList === "PENDING" &&
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" color="#bb1370" height={20} width={20} style={{ display: "inline-block" }} />&nbsp;
                                                    در حال بارگذاری لیست
                                                </div>
                                            }
                                            {
                                                bankList?.Data && Array.isArray(bankList.Data) &&
                                                <select className="form-control" name="AccountID" onChange={setBank} defaultValue={chequefunction.AccountID ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {bankList.Data.map((item, i) => <option value={item.ID} key={i}>{item.BankMixedName}</option>)}
                                                </select>
                                            }

                                        </Fragment>
                                    }

                                </Col>
                                <Col md={2} className="form-group">
                                    <label>تاریخ سند:</label>
                                    <DatePicker isGregorian={false} timePicker={false} className="form-control" onChange={onDateChange}
                                        value={momentJalaali(chequefunction.DocumentDate.substring(0, 10))} />
                                </Col>
                            </Row>
                            {currentRow?.RowIndex >= 0 &&
                                <form onSubmit={handleSubmit(addEditRow)} ref={frmRow}>
                                    <FormGroup style={{ border: "1px solid gray", padding: "8px", borderRadius: "3px", backgroundColor: "#cdd7e273", position: "relative" }} >
                                        {!isMobile &&
                                            <table className="flexTable" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th>شماره چک</th>
                                                        <th>تاریخ سررسید</th>
                                                        <th className="ellipsisLabel" title="نام بانک و شعبه">نام بانک و شعبه</th>
                                                        <th className="ellipsisLabel" title="شماره حساب جاری">شماره حساب جاری</th>
                                                        <th>مبلغ چک</th>
                                                        <th>پشت نمره</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input type="hidden" value={currentRow.RowIndex ?? ""} readOnly name="RowIndex" ref={register({})} />
                                                            <input type="hidden" value={currentRow.ShowIndex ?? ""} readOnly name="ShowIndex" ref={register({})} />
                                                            <input type="hidden" value={currentRow.ChequeID ?? ""} readOnly name="ChequeID" ref={register({})} />
                                                            <input type="hidden" value={currentRow.BankID ?? ""} readOnly name="BankID" ref={register({})} />
                                                            <Form.Control type="number" className="tableRowInput" name="ChequeNumber" ref={e => { register(e, { required: true }); inputChqNum.current = e; }} defaultValue={currentRow.ChequeNumber ?? ""} onKeyDown={showModalSelectCheq} />
                                                            {errors?.ChequeNumber && <small className="errors">شماره چک الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <DatePicker ref={inputDate} className="tableRowInput" calendarStyles={{ marginTop: "15px" }} isGregorian={false} timePicker={false} onChange={val => setCurrentRow({ ...currentRow, DueDate: val.local("en").format("YYYY-MM-DD") })} value={currentRow.DueDate ? momentJalaali(currentRow.DueDate.substring(0, 10)) : null} />
                                                            {(currentRow.DueDate ?? "") === "" && <small className="errors">تاریخ سررسید الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <Form.Control className="tableRowInput" name="BankName" defaultValue={currentRow.BankName ?? ""} /*onChange={onChangeCheqInfo}*/ ref={register({ required: true })} />
                                                            {errors?.BankName && <small className="errors">نام  بانک الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <Form.Control type="number" className="tableRowInput" name="BankAccountNo" defaultValue={currentRow.BankAccountNo ?? ""} /*onChange={onChangeCheqInfo}*/ ref={register({ required: true })} />
                                                            {errors?.BankAccountNo && <small className="errors">شماره حساب الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <NewNumberInput id="chqAmount" className="tableRowInput" inputname="ChequeAmount" defaultValue={currentRow.ChequeAmount ?? ""} /*onChange={onChangeCheqInfo}*/ reff={register({ required: true })} />
                                                            {errors?.ChequeAmount && <small className="errors">مبلغ چک الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <Form.Control type="number" className="tableRowInput" name="ChequeBackNo" defaultValue={currentRow.ChequeBackNo ?? ""} ref={register({})} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        }
                                        <Button className="group-Btn mt-1" variant="success" type="submit">
                                            {Number(currentRow.RowIndex) > 0 &&
                                                <Fragment>
                                                    <Pencil size={17} />&nbsp;ویرایش ردیف
                                                </Fragment>
                                            }
                                            {Number(currentRow.RowIndex) === 0 &&
                                                <Fragment>
                                                    <CheckLg size={15} />&nbsp;ثبـت ردیـف &nbsp;
                                                </Fragment>
                                            }
                                        </Button>
                                        <Button className="group-Btn mt-1" variant="danger" onClick={cancelRow}>
                                            <DashCircle size={16} />&nbsp;انـصـراف&nbsp;
                                        </Button>
                                    </FormGroup>
                                </form>
                            }
                            {!currentRow && <PlusSquareFill className="hoverIcon mt-2" color="#63409e" size={25} onClick={prepareForAdd} />}
                            <BihamtaTable columns={tableCols} rowButtons={tableRows} className="mt-1" /*rowClick={prepareForEdit} */
                                dataList={{ Data: chequefunction?.ChequeFunctionRows ? chequefunction.ChequeFunctionRows.filter(c => !c.SignedForDelete).sort((c, d) => c.ShowIndex - d.ShowIndex) : [] }} />
                            <Row>
                                <Col md={3} className="form-group">
                                    <label>جمع کل: </label>
                                    <Form.Control value={chequefunction.ChequeTotalAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} readOnly />
                                </Col>
                            </Row>
                            {
                                showPay &&
                                <Row className="rowBorder mt-3">
                                    <div className="rowTitle">
                                        {ChequeStatus === chequeStatuses.in_1_RecieveCheque && 'دریافت نقد'}
                                        {ChequeStatus === chequeStatuses.out_1_PayCheque && 'پرداخت نقد'}
                                    </div>
                                    <Col md={3} className="form-group">
                                        <NewNumberInput inputname="CashToPay" defaultValue={Number(chequefunction?.CashToPay ?? 0)} onChange={e => chequefunction.CashToPay = e.target.value} />
                                    </Col>
                                    <Col md={5} className="form-group">
                                        <Form.Control name="CashTargetAccountName" defaultValue={chequefunction.CashTargetAccountName ?? ""} onKeyDown={showModalAccLevel3} readOnly />
                                        <Button className="btn-input-tiny" style={{ top: "8px" }} onClick={showModalAccLevel3}><List size={20} /></Button>
                                    </Col>
                                </Row>
                            }
                            {submitError &&
                                <Row className="mt-2" style={{ margin: 0 }}>
                                    <Alert variant={submitError.Variant} style={{ width: "85%" }}><ExclamationTriangle size={18} />&nbsp; {submitError.Message}
                                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                                    </Alert>
                                </Row>
                            }
                            <div className="mt-2">
                                <Button className="group-Btn" variant="success" onClick={submitChequeFunction} disabled={pending}>
                                    <CheckLg size={16} />&nbsp; ثبت اطلاعات
                                </Button>
                                {Number(chequefunction?.FunctionID) > 0 &&
                                    <Button className="group-Btn" variant="danger" onClick={deleteF}>
                                        <Trash size={16} />&nbsp; حذف عملیات
                                    </Button>
                                }
                                {Number(chequefunction.DocumentID) > 0 &&
                                    <Fragment>
                                        <Button variant="secondary" className="group-Btn" onClick={printCheque} style={{ marginRight: "12px" }}><Printer size={16} /> &nbsp;چاپ چک</Button>
                                        <Button className="group-Btn" onClick={gotoDocument}><Book size={16} />&nbsp; سند حسابداری</Button>
                                        <Button variant="light" className="group-Btn btn-violet" onClick={newCheue}><PlusSquare size={16} />&nbsp;چک جدید</Button>
                                    </Fragment>}
                            </div>
                        </Fragment>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default ModalAddEditChequeFunctions;